import React from "react";
import Stars from "components/stars";
import Image from "components/image";
import getModulePadding from "helpers/get-module-padding";

const CollectionDetails = ({ data: { author, infoImage, subtitle, title, vehicleImage, sideImage } }) => (
    <div className="container">
        <div className={`flex lg:flex-row flex-col justify-between lg:items-center xl:mt-2.5 ${getModulePadding()}`}>
            <div className="flex flex-col lg:max-w-[25rem] overflow-hidden">
                <div className="flex flex-col mb-5">
                    <h2 className="bg-blue-700 text-white text-[2.5rem] leading-10 font-medium p-2 pr-16 w-fit mb-2"> 
                        {title}
                    </h2>
                    <h3 className="bg-orange-701 text-white text-[2.5rem] leading-10 font-medium p-2 pr-16 w-fit"> 
                        {subtitle}
                    </h3>
                </div>
                {sideImage?.asset ? (
                    <Image image={sideImage?.asset} alt={sideImage?.alt} />
                ) : (
                    <>
                        <Stars rating={5} className="!gap-0 mb-5" />
                        <div className="text-sm text-gray-600">
                            <p className="mb-1 text-sm"> 
                                {author?.review}
                            </p>
                            <p className="text-sm"> 
                                {author?.name}
                            </p>
                        </div>  
                    </>
                )}
            </div>
            <div className="flex items-center md:flex-row flex-col">
                <div className="md:max-w-[415px] w-full h-fit">
                    <Image image={vehicleImage?.asset} alt={vehicleImage?.alt} />
                </div>
                <div className="md:max-w-[320px] w-full h-fit">
                    <Image image={infoImage?.asset} alt={infoImage?.alt} />
                </div>
            </div>
        </div>
    </div>
);

export default CollectionDetails;
